module.exports = __webpack_public_path__ + "img/1454331230.cb48f503.jpg";